import { render } from "./ProPointUpdateModal.vue?vue&type=template&id=7ddf6d83"
import script from "./ProPointUpdateModal.vue?vue&type=script&lang=js"
export * from "./ProPointUpdateModal.vue?vue&type=script&lang=js"

import "./ProPointUpdateModal.vue?vue&type=style&index=0&id=7ddf6d83&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__